import $ from 'jquery';
import ajaxSearchCars from './sopimus-ajax-search-car';
import slider from 'bootstrap-slider';
import ajax from '../libs/ajax';

const searchSlider = {
  init: function() {
    ajax.ajaxRequest({
      target: 'getPriceRange',
      callback: function(data) {
        let originalVal;
        $('#price-range').slider({
          min: data.min,
          max: data.max,
          tooltip_split: true,
          tooltip_position: 'bottom',
          value: [data.min, data.max]
        });
        $('.tooltip-main').hide();
        window.searchOptions.min = data.min;
        window.searchOptions.max = data.max;
        console.log('window.searchOptions ', window.searchOptions);

        ajaxSearchCars(window.searchOptions);

        $('#price-range')
          .slider()
          .on('slideStart', function(ev) {
            originalVal = $('#price-range')
              .data('slider')
              .getValue();
          });
        const searchOptions = {};
        $('#price-range')
          .slider()
          .on('slideStop', function(ev) {
            let newVal = $('#price-range')
              .data('slider')
              .getValue();
            // If change value
            if (originalVal != newVal) {
              searchOptions.min = $('#price-range')
                .val()
                .split(',')[0];
              searchOptions.max = $('#price-range')
                .val()
                .split(',')[1];
              window.searchOptions = { ...window.searchOptions, ...searchOptions };
              ajaxSearchCars(window.searchOptions);
            }
          });
      }
    });
  }
};
module.exports = searchSlider;
